export default function AppCredit() {
  return (
    <div className="app-credit">
      <span className="app-credit__flag" aria-hidden="true">
        <svg viewBox="0 0 2 3" focusable="false">
          <rect width="2" height="1" fill="#ed2939" />
          <rect y="1" width="2" height="1" fill="#fff" />
          <rect y="2" width="2" height="1" fill="#002395" />
        </svg>
      </span>
      <p className="app-credit__text">Créé et développé par Rony Lhomer - 2026</p>
    </div>
  );
}
